import React from 'react';
import { AddContactRequest } from '../../services/api';
import { X } from 'lucide-react';
import './CaseModals.css';

interface AddContactModalProps {
  isOpen: boolean;
  contactData: AddContactRequest;
  setContactData: (data: AddContactRequest) => void;
  isAdding: boolean;
  onClose: () => void;
  onAdd: () => void;
}

const AddContactModal: React.FC<AddContactModalProps> = ({
  isOpen,
  contactData,
  setContactData,
  isAdding,
  onClose,
  onAdd,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop" onClick={onClose}></div>
      <div className="add-contact-modal">
        <div className="modal-header">
          <h2>Add Contact</h2>
          <button onClick={onClose} className="close-modal-btn">
            <X size={24} />
          </button>
        </div>

        <div className="modal-content">
          <div className="form-group">
            <label htmlFor="contact-name">Name *</label>
            <input
              id="contact-name"
              type="text"
              value={contactData.name}
              onChange={(e) => setContactData({ ...contactData, name: e.target.value })}
              placeholder="Enter contact name"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="contact-role">Role *</label>
            <input
              id="contact-role"
              type="text"
              value={contactData.role}
              onChange={(e) => setContactData({ ...contactData, role: e.target.value })}
              placeholder="e.g., Witness, Attorney, Expert"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="contact-email">Email</label>
            <input
              id="contact-email"
              type="email"
              value={contactData.email || ''}
              onChange={(e) => setContactData({ ...contactData, email: e.target.value })}
              placeholder="Enter email address"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="contact-phone">Phone</label>
            <input
              id="contact-phone"
              type="tel"
              value={contactData.phone || ''}
              onChange={(e) => setContactData({ ...contactData, phone: e.target.value })}
              placeholder="Enter phone number"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="contact-address">Address</label>
            <textarea
              id="contact-address"
              value={contactData.address || ''}
              onChange={(e) => setContactData({ ...contactData, address: e.target.value })}
              placeholder="Enter address"
              className="form-textarea"
              rows={3}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="cancel-btn">
            Cancel
          </button>
          <button
            onClick={onAdd}
            disabled={!contactData.name || !contactData.role || isAdding}
            className="add-btn"
          >
            {isAdding ? 'Adding...' : 'Add Contact'}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddContactModal;

